/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MultiviewInputs */



/**
* | output |
* | --- |
* | "Multiview" |
*
* @param {MultiviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const multiview = /** @type {((inputs?: MultiviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MultiviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Multivue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Multiview")
	if (locale === "it") return /** @type {LocalizedString} */ ("Multivista")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Многооконный режим")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista múltiple")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("多视图")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マルチビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मल्टीव्यू")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Visão múltipla")
	return /** @type {LocalizedString} */ ("Multiview")
});